import { IconButton } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Styles from './overviewRedesign.module.css';
import { useCallback, useState } from 'react';
import iconTitle from '../../assets/iconTitle.svg';
import { postUpload } from 'services/upload.service';

export function DigitalStamps(): JSX.Element {
  const [passwordDigitalSea, setPasswordDigitalSea] = useState<string>('');
  const [fileCer, setFileCer] = useState<string | undefined>(undefined);
  const [fileKey, setFileKey] = useState<string | undefined>(undefined);
  const [fileNameDigitalSeaCer, setFileNameDigitalSeaCer] = useState<string | undefined>(undefined);
  const [fileNameDigitalSeaKey, setFileNameDigitalSeaKey] = useState<string | undefined>(undefined);

  const resetForm = () => {
    setFileCer(undefined);
    setFileKey(undefined);
    setFileNameDigitalSeaCer(undefined);
    setFileNameDigitalSeaKey(undefined);
    setPasswordDigitalSea('');
  };

  const handleFileChangeDigitalSeaCer = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFileNameDigitalSeaCer(file.name);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        if (reader.result) {
          setFileCer(reader.result.toString().split(';base64,')[1]);
        }
      };
    }
  };

  const handleFileChangeDigitalSeaKey = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFileNameDigitalSeaKey(file.name);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        if (reader.result) {
          setFileKey(reader.result.toString().split(';base64,')[1]);
        }
      };
    }
  };

  const postSeasDigital = useCallback(async () => {
    try {
      const formData = {
        certificate: fileCer,
        privateKey: fileKey,
        password: passwordDigitalSea,
      };
      await postUpload(formData);
      alert('Se han subido los sellos correctamente');
      resetForm(); // Restaurar el estado inicial al terminar
    } catch (error) {
      alert(error?.response?.data?.message || 'Error al subir los sellos');
    } 
  }, [fileCer, fileKey, passwordDigitalSea]);

  return (
    <div className={Styles.activitiesModal}>
      <div className={Styles.activitiesContainerTitle}>
        <img src={iconTitle} alt="icon" />
        <h3>Subir sellos</h3>
      </div>
      <div className={Styles.inputsContainer}>
        <div className={Styles.eSignatureContainer}>
          <span>{fileNameDigitalSeaCer || 'Sello_digital_1.cer'}</span>
          <IconButton aria-label="upload" component="label">
            <input hidden accept=".cer" type="file" onChange={handleFileChangeDigitalSeaCer} />
            <AttachFileIcon fontSize="small" />
          </IconButton>
        </div>
        <div className={Styles.eSignatureContainer}>
          <span>{fileNameDigitalSeaKey || 'Sello_digital_2.key'}</span>
          <IconButton aria-label="upload" component="label">
            <input hidden accept=".key" type="file" onChange={handleFileChangeDigitalSeaKey} />
            <AttachFileIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      <div className={Styles.containerPassword}>
        <input
          placeholder="Contraseña"
          type="password"
          className={Styles.inputPassword}
          value={passwordDigitalSea}
          onChange={(e) => setPasswordDigitalSea(e.target.value)}
        />
        <button onClick={postSeasDigital} className={Styles.buttonPassword}>
          Subir sellos digitales
        </button>
      </div>
    </div>
  );
}
